import Vue from 'vue'
import eventLabelApi from '@/api/eventLabel.api'

const state = {
  labels: {}
}


const getters = {
  eventLabelById: (state) => (id) => {
    return state.labels[id]
  },

  eventLabels: (state) => {
    return Object.values(state.labels)
  }
}


const actions = {
  async loadEventLabels ({ commit, rootState }) {
    const response = await eventLabelApi.getLabels(rootState.tenant.current)
    commit('SET_LABELS', response.data)
  },

  async createEventLabel ({ commit, rootState }, label) {
    const response = await eventLabelApi.createLabel(rootState.tenant.current, label)
    commit('CREATE_LABEL', response.data)
  },

  async updateEventLabel ({ commit, rootState }, label) {
    await eventLabelApi.updateLabel(rootState.tenant.current, label.id, label)
    commit('UPDATE_LABEL', label)
  },

  async deleteEventLabel ({ commit, dispatch, rootState }, id) {
    await eventLabelApi.deleteLabel(rootState.tenant.current, id)
    commit('DELETE_LABEL', id)
    dispatch('event/removeLabelFromAllEvents', id, { root: true })
  }
}


const mutations = {
  SET_LABELS (state, labels) {
    state.labels = {}
    for (const label of labels) {
      Vue.set(state.labels, label.id, label)
    }
  },

  CREATE_LABEL (state, label) {
    Vue.set(state.labels, label.id, label)
  },

  UPDATE_LABEL (state, label) {
    Vue.set(state.labels, label.id, label)
  },

  DELETE_LABEL (state, id) {
    Vue.delete(state.labels, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
